/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/require-await */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-use-before-define */
import {Button, Form, InputGroup} from 'react-bootstrap';
import {useNavigate, useLocation} from 'react-router-dom';
import {toast} from 'react-toastify';
import type {SubmitHandler} from 'react-hook-form';
import {useForm} from 'react-hook-form';
import {useState, useEffect} from 'react';

import LayoutMain from 'components/Layouts/LayoutMain';
import {
	useDataOperatorTemplateMutation,
	useUpdateDataOperatorTemplateMutation,
} from 'services';
import type {Operator} from 'interfaces';

const stylePadding = {paddingLeft: '0.5rem'};

const SubscriberOperatorsDetail = () => {
	const navigate = useNavigate();
	const location = useLocation();

	const {state} = location;
	const [isEdit, setIsEdit] = useState(false);

	useEffect(() => {
		setIsEdit(state?.name?.length > 0);
	}, [state?.name]);

	const {
		register,
		handleSubmit,
		formState: {errors},
	} = useForm<Operator>({
		mode: 'all',
		defaultValues: defaultData(state) as never,
	});

	const [saveDataOperatorTemplate, {isLoading}] =
		useDataOperatorTemplateMutation();
	const [updateDataOperatorTemplate, {isLoading: isLoadingUpdate}] =
		useUpdateDataOperatorTemplateMutation();

	/**
	 * The above function is a TypeScript React function that handles form submission and performs some
	 * data manipulation and API calls.
	 */
	const onSubmit: SubmitHandler<Operator> = async formData => {
		try {
			if (isEdit) {
				await updateDataOperatorTemplate({
					...formData,
					id: state?.id,
				} as never).unwrap();
			} else {
				await saveDataOperatorTemplate(formData as never).unwrap();
				setIsEdit(true);
			}

			toast.success(`${isEdit ? 'Update' : 'Create'} Successfully!`);
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<LayoutMain isLoading={isLoading || isLoadingUpdate}>
			<div className="container-fluid">
				{/* Intro */}
				<div className="row">
					<div className="col-md-12">
						<h1 className="mt-2">Subscriber Profile Management</h1>
					</div>
				</div>

				<nav aria-label="breadcrumb">
					<ol className="breadcrumb">
						<li className="breadcrumb-item">
							<span
								role="button"
								className="text-primary"
								onClick={() => navigate(-1)}>
								Subscriber Profile Management
							</span>
						</li>
						<li className="breadcrumb-item active" aria-current="page">
							{isEdit ? 'Edit' : 'Create'}
						</li>
					</ol>
				</nav>

				{/* Subscriber Profile Management*/}
				<div className="row mt-4">
					<div className="col-md-12">
						<div className="card-tasks card">
							<div className="card-header">
								<i className="bi bi-person-lines-fill mr-3 float-left text-primary bi-2-5" />
								<h2 className="card-title">
									{isEdit ? 'Edit Operator' : 'New Operator'}
								</h2>
								<p className="card-category">
									{isEdit
										? 'Edit the existent operator'
										: 'Create a new operator'}
								</p>
							</div>
							<div className="card-body">
								<div className="mt-1">
									<div className="row mb-5 d-flex justify-content-center align-items-center">
										<div className="col-xs-12 col-xl-6">
											<Form
												className="rounded-3 text-bg-light p-2 needs-validation"
												onSubmit={handleSubmit(onSubmit)}>
												<h2>Operator</h2>

												<InputGroup className="mb-3">
													<InputGroup.Text style={stylePadding}>
														Name
													</InputGroup.Text>
													<Form.Control
														id="name"
														aria-label="name"
														placeholder=""
														{...register('name', {
															required: 'The field is required',
														})}
														className={errors.name ? 'is-invalid' : ''}
													/>
													{errors.name && (
														<small className="invalid-feedback d-block">
															{errors.name.message}
														</small>
													)}
												</InputGroup>

												<Button
													type="submit"
													className="mt-2"
													variant="primary"
													style={{color: 'white'}}>
													{isEdit ? 'Update' : 'Create'}
												</Button>
											</Form>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</LayoutMain>
	);
};

export const defaultData = (state?: Operator) => ({
	name: state?.name || '',
});

export default SubscriberOperatorsDetail;
